(() => {
  const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char]);
  const hasPayload = (payload) => {
    if (!payload) return false;
    if (Array.isArray(payload)) return payload.length > 0;
    if (typeof payload !== "object") return Boolean(payload);
    const state = String(payload.status || payload.state || payload.delivery_status || "").toLowerCase();
    if (["not_found", "notfound", "no_data", "empty", "error", "failed"].includes(state)) return false;
    if (payload.found === false || payload.success === false || payload.data === null) return false;
    return Object.keys(payload).length > 0;
  };
  const requestCarrier = async (carrier, number, timeout) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const url = new URL(carrier.endpoint, location.origin);
      url.searchParams.set("tracking_number", number);
      url.searchParams.set("trackingNumber", number);
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: controller.signal });
      if (!response.ok) return null;
      const type = response.headers.get("content-type") || "";
      const payload = type.includes("application/json") ? await response.json() : await response.text();
      return hasPayload(payload) ? payload : null;
    } catch (_) {
      return null;
    } finally {
      clearTimeout(timer);
    }
  };
  const formatValue = (value) => {
    if (value == null) return "";
    if (Array.isArray(value)) return value.map(formatValue).filter(Boolean).join(", ");
    if (typeof value === "object") return Object.entries(value).slice(0, 8).map(([key, item]) => `${key}: ${formatValue(item)}`).join(" | ");
    return String(value);
  };
  const initialize = (widget) => {
    if (widget.dataset.initialized) return;
    widget.dataset.initialized = "true";
    const form = widget.querySelector("[data-track-order-form]");
    const input = widget.querySelector("[data-track-order-input]");
    const submit = widget.querySelector("[data-track-order-submit]");
    const status = widget.querySelector("[data-track-order-status]");
    const result = widget.querySelector("[data-track-order-result]");
    const carriers = [...widget.querySelectorAll("[data-track-order-carrier]")].map((node) => ({ name: node.dataset.name, endpoint: node.dataset.endpoint || node.dataset.defaultEndpoint })).filter((item) => item.endpoint);
    form.addEventListener("submit", async (event) => {
      var _a;
      event.preventDefault();
      const number = input.value.trim();
      if (!number) return;
      submit.disabled = true;
      result.hidden = true;
      result.textContent = "";
      let match = null;
      for (const carrier of carriers) {
        status.textContent = `Recherche via ${carrier.name}\u2026`;
        const payload = await requestCarrier(carrier, number, Number(widget.dataset.timeoutMs) || 3e3);
        if (payload) {
          match = { carrier, payload };
          break;
        }
      }
      if (match) {
        const source = ((_a = match.payload) == null ? void 0 : _a.data) || match.payload;
        const rows = Object.entries(typeof source === "object" ? source : { information: source }).slice(0, 8).map(([key, value]) => `<div><dt>${escapeHtml(key.replace(/[_-]/g, " "))}</dt><dd>${escapeHtml(formatValue(value))}</dd></div>`).join("");
        status.textContent = `Suivi trouv\xE9 via ${match.carrier.name}.`;
        result.innerHTML = `<dl>${rows}</dl>`;
        result.hidden = false;
      } else {
        const email = escapeHtml(widget.dataset.supportEmail);
        status.innerHTML = `Aucun suivi trouv\xE9. Contactez <a href="mailto:${email}">${email}</a>.`;
      }
      submit.disabled = false;
    });
  };
  const initializeAll = (root = document) => root.querySelectorAll("[data-track-order]").forEach(initialize);
  document.addEventListener("DOMContentLoaded", () => initializeAll());
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
